export default __webpack_public_path__ + "static/media/client-13.323a626b.png";